


















import { Vue, Component } from "vue-property-decorator";

import { ChatExportDataLoader, ExportStage } from "../data/ChatExportDataLoader";
import { Room } from "../../chat/models/Rooms/Room";
import RoomType  from "../../chat/enums/ChatTypes";
import MessagesHelper from "../../chat/helpers/MessagesHelper";
import ModalWindow from "../../../service/components/modal/Modal.vue";
import ExportPreview from "./ExportPreview.vue";

import { UserProfile } from "../../../api/models/UserProfile";

@Component({
    components: { ModalWindow, ExportPreview }
})
export default class ChatExport extends Vue {

    stages: ExportStage[] = [];
    loaded = false;
    error = false;

    mounted() {
        this.getData();
        this.addClassForPrinting();

        window.addEventListener('beforeprint', this.addPrintClassFromModal);
        window.addEventListener('afterprint', this.removePrintClassFromModal);
    }

    addPrintClassFromModal() {
        const element = document.querySelector(".modal-window");
        element?.classList.add("ios-print-element-breaking-fix")
    }

    removePrintClassFromModal() {
        const element = document.querySelector(".modal-window");
        element?.classList.remove("ios-print-element-breaking-fix");
    }

    print() {
        this.addPrintClassFromModal();
        window.print()
    }

    addClassForPrinting() {
        document.body.classList.add("chat-export-printing");
    }

    removeClassForPrinting() {
        document.body.classList.remove("chat-export-printing");
    }

    beforeDestroy() {
        this.removeClassForPrinting();

        window.removeEventListener('beforeprint', this.addPrintClassFromModal);
        window.removeEventListener('afterprint', this.removeClassForPrinting);
    }

    async getData() {

        this.$store.dispatch('showSpinner');

        try {
            const dataLoader = new ChatExportDataLoader(this.$repositories, new MessagesHelper(), this.rooms, this.users, this.$store.state.session.language || 'en');

            this.stages = (await dataLoader.getAllRooms() || []).sort((a, b) => {

                const aString = a.user?.lastName || a.title.split(" ", 2)[1] || a.title;
                const bString = b.user?.lastName || b.title.split(" ", 2)[1] || b.title;

                if (aString > bString) {
                    return 1;
                }
                if (aString < bString) {
                    return -1
                }
                return 0;
            })

            this.loaded = true;
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
            this.loaded = true;
            this.error = true;
        }
        finally {
            this.$store.dispatch("hideSpinner");
        }
    }

    get rooms(): Room[] {
        return this.$store.state.chat.rooms.list.filter((room: Room) => room.type === RoomType.direct && !room.isHidden);
    }

    get users(): Record<number, UserProfile> {
        return this.$store.state.chat.profiles.list || null;
    }
}
